module.exports = __webpack_public_path__ + "public/img/企业文化CULTURE_EN.2845708a.png";